import { useQuery } from '@tanstack/react-query';
import { attemptGetLiveAccessPointsStatus } from 'api/OrgApi';

export const useGetLiveAccessPointsStatus = (payload) => {
  return useQuery({
    queryKey: ['liveConnectionStats', payload],
    queryFn: () => attemptGetLiveAccessPointsStatus(payload),
    enabled: !!payload, // Ensure the query only runs if payload is not null
  });
};